class BroadcastClient {
  constructor(name) {
    this.name = name
    this.broadcastChannel = null
    this.unsupportedBrowser = false
    this.boundEvents = []
  }

  init() {
    if (!this.broadcastChannel) {
      try {
        this.broadcastChannel = new BroadcastChannel(this.name)
      } catch (err) {
        this.unsupportedBrowser = true
        console.error(err)
      }
    }
  }

  // At most one listener per event for the life of the channel. The socket
  // middlewares register their handlers inside the CONNECT case, and CONNECT is
  // re-dispatched every time the socket drops and comes back — without this
  // guard each reconnect stacked another listener, so one broadcast message was
  // handled two, three, N times over. That showed up as live transcript
  // utterances (and chat messages) rendering repeated.
  on(eventName, callback) {
    if (this.boundEvents.includes(eventName)) {
      return
    }

    this.boundEvents.push(eventName)
    this.broadcastChannel.addEventListener(eventName, callback)
  }

  close() {
    if (this.broadcastChannel) {
      this.broadcastChannel.close()
      this.broadcastChannel = null
      // The channel is gone, so its listeners are too — the next init() has to
      // be allowed to bind again.
      this.boundEvents = []
    }
  }
}

export { BroadcastClient }
